import React, { createContext, useContext, useState, useEffect } from 'react';

const FontSizeContext = createContext();

const SIZES = [
    { key: 'normal', label: 'Normal', scale: 1.0  },
    { key: 'medio',  label: 'Médio',  scale: 1.12 },
    { key: 'grande', label: 'Grande', scale: 1.25 },
    { key: 'enorme', label: 'Enorme', scale: 1.4  },
];

export const FontSizeProvider = ({ children }) => {
    const [sizeKey, setSizeKey] = useState(
        () => localStorage.getItem('fontSizeKey') || 'normal'
    );

    useEffect(() => {
        const size = SIZES.find(s => s.key === sizeKey) || SIZES[0];

        // ✅ Aplica como variável CSS — usada no App.css
        document.documentElement.style.setProperty('--font-scale', size.scale);

        // ✅ Aplica também no font-size do <html> para escalar rem
        document.documentElement.style.fontSize = `${size.scale * 16}px`;

        // ✅ Salva preferência
        localStorage.setItem('fontSizeKey', sizeKey);
    }, [sizeKey]);

    return (
        <FontSizeContext.Provider value={{ sizeKey, setSizeKey, SIZES }}>
            {children}
        </FontSizeContext.Provider>
    );
};

export const useFontSize = () => useContext(FontSizeContext);
